import React from "react";

import Applet from "../../Applet";
import ProjectPlanPhaseReferenceTable from "../../../../components/ProjectPlan/ProjectPlanPhaseReferenceTable";

class ProjectPlanPhaseReferenceTableApplet extends Applet {

    render() {
        return <ProjectPlanPhaseReferenceTable applet={this}
                                 pageSize={this.state.PageSize}
                                 placement={this.state.Placement}
                                 columns={this.state.Columns}
                                 title="References"
                                 enterpriseComponent={this.getEnterpriseComponent()}
                                 sort={this.state.Sort}
                                 menu={this.state.Menu}
                                 rowHeight={this.state.RowHeight}
                                 simpleSearch={this.state.SimpleSearch}
                               // enableSort={true}
                               // enableSearch={true}

        />;
    }

    state = {
        Name: "ProjectPlanPhaseMilestoneReferenceTableApplet",
        Menu: {
            options: [
                {
                    privileges: [
                        "Add Milestone Reference"
                    ],
                    displayValue: "New Reference",
                    value: "New Reference",
                },
                {
                    displayValue: "Refresh",
                    value: "Refresh",
                },
            ],
        },
        RowHeight: 60,
        PageSize: {
            "default": 20,
            "xs": 3,
            "sm": 3,
            "md": 10,
            "lg": 20,
            "lx": 20,
        },
        Placement: {
            "xl": [
                {
                    id: "MilestoneName",
                },
                {
                    id: "ReferenceType",
                },
                {
                    id: "DocumentID",
                },
                {
                    id: "DisplayRevision",
                },
                {
                    id: "Name",
                },
                {
                    id: "ApprovalRequestID",
                },
                {
                    id: "DisplayStatus",
                },
                {
                    id: "Status",
                },
                {
                    id: "ReleasedAt",
                },
                {
                    id: "Comment",
                },
                {
                    id: "Actions",
                },

            ]
        },
        Columns: [
            {
                id: "MilestoneName",
                width: 240,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Milestone Name",
            },
            {
                id: "ReferenceType",
                width: 140,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Reference Type",
            },
            {
                id: "DocumentID",
                width: 140,
                cellRenderer: "D2M Hyperlink Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "ID",
            },
            {
                id: "DisplayRevision",
                width: 70,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Rev",
            },
            {
                id: "Name",
                width: 230,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Title",
            },
            {
                id: "ApprovalRequestID",
                width: 140,
                cellRenderer: "Approval Request Hyperlink Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "AR ID",
            },
            {
                id: "DisplayStatus",
                width: 150,
                cellRenderer: "State Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "State",
            },
            {
                id: "Status",
                width: 150,
                cellRenderer: "Status Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Status",
            },
            {
                id: "ReleasedAt",
                width: 180,
                cellRenderer: "Local Date Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Released Date",
            },
            {
                id: "Comment",
                width: 400,
                cellRenderer: "Standard Single Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "Comment",
            },
            {
                id: "Actions",
                width: 50,
                cellRenderer: "Action Cell",
                header: "enabled",
                headerRenderer: "Standard Single Header",
                headerTitle: "",
                pinned: "right",
                hideable: false,
            }
        ],
        Sort: [
            {
                "Identifier": "DocumentID",
                "Visible": true,
                "Default": true,
                "Options": [{
                    "Direction": "ASC",
                    "SortAttribute": "DocumentID",
                    "DisplayName": "ID",
                }],
            },
            {
                "Identifier": "ApprovalRequestID",
                "Visible": true,
                "Default": false,
                "Options": [{
                    "Direction": "ASC",
                    "SortAttribute": "ApprovalRequestID",
                    "DisplayName": "AR ID",
                }
                ]
            },
            {
                "Identifier": "Status",
                "Visible": true,
                "Default": false,
                "Options": [{
                    "Direction": "ASC",
                    "SortAttribute": "Status",
                    "DisplayName": "State",
                }
                ]
            },
            {
                "Identifier": "ReferenceType-ID",
                "Visible": true,
                "Default": false,
                "Options": [{
                    "Direction": "ASC",
                    "SortAttribute": "ReferenceType",
                    "DisplayName": "Reference Type",
                }, {
                    "Direction": "ASC",
                    "SortAttribute": "DocumentID",
                    "DisplayName": "ID",
                }
                ]
            }
        ],
        SimpleSearch: {
            Actions: {
                Query: {
                    Groups: [
                        {
                            "identifier": "group1",
                            "type": "standard",
                            "selector": null,
                            "characteristics": [],
                            "membership": [
                                {
                                    id: "ReferenceType",
                                },
                                {
                                    id: "DocumentID",
                                },
                                {
                                    id: "Name",
                                },
                                {
                                    id: "DisplayStatus",
                                }
                            ]
                        }
                    ]
                }
            },
            Controls: {
                "ReferenceType": {
                    id: "ReferenceType",
                    enterpriseComponentAttribute: "ReferenceType",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 4,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Reference Type",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "Select",
                    requiresConfirmation: false,
                },
                "DocumentID": {
                    id: "DocumentID",
                    enterpriseComponentAttribute: "DocumentID",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 4,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [
                        {
                            validator: "No Special Characters",
                            value: null,
                            errorText: "Field must not have special characters.",
                        },
                        {
                            validator: "No Leading Spaces",
                            value: null,
                            errorText: "Field must not have leading spaces.",
                        },
                        {
                            validator: "Not All Spaces",
                            value: null,
                            errorText: "Field must not have all spaces.",
                        },

                    ],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "ID",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "TextField",
                    requiresConfirmation: false,
                },
                "DisplayStatus": {
                    id: "DisplayStatus",
                    enterpriseComponentAttribute: "DisplayStatus",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 4,
                            lg: 3,
                            xl: 3
                        }
                    },
                    errors: [
                        {
                            validator: "No Special Characters",
                            value: null,
                            errorText: "Field must not have special characters.",
                        },
                        {
                            validator: "No Leading Spaces",
                            value: null,
                            errorText: "Field must not have leading spaces.",
                        },
                        {
                            validator: "Not All Spaces",
                            value: null,
                            errorText: "Field must not have all spaces.",
                        },

                    ],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "State",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "TextField",
                    requiresConfirmation: false,
                },
                "Name": {
                    id: "Name",
                    enterpriseComponentAttribute: "Name",
                    placement: {
                        "Query": {
                            xs: 12,
                            sm: 6,
                            md: 4,
                            lg: 6,
                            xl: 6
                        }
                    },
                    errors: [
                        {
                            validator: "No Special Characters",
                            value: null,
                            errorText: "Field must not have special characters.",
                        },
                        {
                            validator: "No Leading Spaces",
                            value: null,
                            errorText: "Field must not have leading spaces.",
                        },
                        {
                            validator: "Not All Spaces",
                            value: null,
                            errorText: "Field must not have all spaces.",
                        },

                    ],
                    csp: {
                        autoFocus: false,
                        multiline: false,
                        placeholder: null,
                        label: "Title",
                        disabled: false,
                        size: "small"
                    },
                    ip: {},
                    type: "TextField",
                    requiresConfirmation: false,
                },
            }
        }
    }
}

export default ProjectPlanPhaseReferenceTableApplet;
